

  interface ApiCategory {
  category: string;
  subcategory?: string;
  action: string;
  flow: string;
  step: number;
  businessDomain: string;
  accessLevel: 'public' | 'authenticated' | 'admin' | 'super-admin';
  dataFlow: 'read' | 'write' | 'read-write';
}

export const apiCategories: { [key: string]: ApiCategory } = {
  
  // ==================== AUTHENTICATION & SECURITY ====================
  'auth': {
    category: 'Authentication',
    action: 'Auth Module',
    flow: 'Auth Flow',
    step: 1,
    businessDomain: 'Security',
    accessLevel: 'public',
    dataFlow: 'read-write'
  },
  'auth/tfa-verify': {
    category: 'Authentication',
    subcategory: 'Two-Factor Authentication',
    action: 'TFA Verification',
    flow: 'Security Flow',
    step: 1,
    businessDomain: 'Security',
    accessLevel: 'authenticated',
    dataFlow: 'read-write'
  },
  'auth/tfa-setup': {
    category: 'Authentication',
    subcategory: 'Two-Factor Authentication',
    action: 'TFA Setup',
    flow: 'Security Flow',
    step: 2,
    businessDomain: 'Security',
    accessLevel: 'authenticated',
    dataFlow: 'write'
  },
  'change-password': {
    category: 'Authentication',
    action: 'Password Change',
    flow: 'Security Flow',
    step: 3,
    businessDomain: 'Security',
    accessLevel: 'authenticated',
    dataFlow: 'write'
  },

  // ==================== GENERAL & USER MANAGEMENT ====================
  'general': {
    category: 'General',
    action: 'General Operations',
    flow: 'General Flow',
    step: 1,
    businessDomain: 'Administration',
    accessLevel: 'authenticated',
    dataFlow: 'read-write'
  },
  'userManagement': {
    category: 'User Management',
    action: 'User Management Operations',
    flow: 'User Flow',
    step: 1,
    businessDomain: 'Administration',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },

  // ==================== RESELLER MANAGEMENT ====================
  'reseller': {
    category: 'Reseller Management',
    action: 'Reseller Setup',
    flow: 'Reseller Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'reseller-onboarding': {
    category: 'Reseller Management',
    subcategory: 'Onboarding',
    action: 'Reseller Onboarding',
    flow: 'Onboarding Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },

  // ==================== MERCHANT MANAGEMENT ====================
  'merchants': {
    category: 'Merchant Management',
    action: 'Merchant Setup',
    flow: 'Merchant Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'merchants/new-onboarding': {
    category: 'Merchant Management',
    subcategory: 'Onboarding',
    action: 'New Merchant Onboarding',
    flow: 'Onboarding Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'merchantScreening': {
    category: 'Merchant Management',
    subcategory: 'Compliance',
    action: 'Merchant Screening',
    flow: 'Compliance Flow',
    step: 1,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'merchantCompliance': {
    category: 'Merchant Management',
    subcategory: 'Compliance',
    action: 'Merchant Compliance',
    flow: 'Compliance Flow',
    step: 2,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'negativeMerchant': {
    category: 'Merchant Management',
    subcategory: 'Risk Management',
    action: 'Negative Merchant List',
    flow: 'Risk Flow',
    step: 1,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'merchantReport': {
    category: 'Merchant Management',
    subcategory: 'Reporting',
    action: 'Merchant Report',
    flow: 'Reporting Flow',
    step: 1,
    businessDomain: 'Analytics',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'merchantTransactionReport': {
    category: 'Merchant Management',
    subcategory: 'Transaction Reports',
    action: 'Merchant Transaction Report',
    flow: 'Reporting Flow',
    step: 2,
    businessDomain: 'Analytics',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },

  // ==================== CUSTOMER MANAGEMENT ====================
  'customerMaster': {
    category: 'Customer Management',
    action: 'Customer Master',
    flow: 'Customer Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'authenticated',
    dataFlow: 'read-write'
  },

  'screening': {
    category: 'Customer Management',
    action: 'Customer Master',
    flow: 'Customer Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'authenticated',
    dataFlow: 'read-write'
  },
  'customerApprove': {
    category: 'Customer Management',
    subcategory: 'Approval',
    action: 'Customer Approval',
    flow: 'Approval Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'customerEvent': {
    category: 'Customer Management',
    subcategory: 'Activity',
    action: 'Customer Events',
    flow: 'Activity Flow',
    step: 1,
    businessDomain: 'Analytics',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'customerEdit': {
    category: 'Customer Management',
    subcategory: 'Edit',
    action: 'Customer Edit',
    flow: 'Customer Flow',
    step: 2,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'customerTransactionReport': {
    category: 'Customer Management',
    subcategory: 'Transaction Reports',
    action: 'Customer Transaction Report',
    flow: 'Reporting Flow',
    step: 1,
    businessDomain: 'Analytics',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'customerWalletLedger': {
    category: 'Customer Management',
    subcategory: 'Financial',
    action: 'Customer Wallet Ledger',
    flow: 'Financial Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'customerReconciliationReport': {
    category: 'Customer Management',
    subcategory: 'Reconciliation',
    action: 'Customer Reconciliation Report',
    flow: 'Reconciliation Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'customerBlocked': {
    category: 'Customer Management',
    subcategory: 'Security',
    action: 'Customer Block',
    flow: 'Security Flow',
    step: 1,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'customer-dashboard': {
    category: 'Customer Management',
    subcategory: 'Dashboard',
    action: 'Customer Dashboard',
    flow: 'Dashboard Flow',
    step: 1,
    businessDomain: 'Analytics',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'merchant-dashboard': {
    category: 'Merchant Management',
    subcategory: 'Dashboard',
    action: 'Merchant Dashboard',
    flow: 'Dashboard Flow',
    step: 1,
    businessDomain: 'Analytics',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },

  // ==================== COMPLIANCE & SCREENING ====================
  'pep': {
    category: 'Compliance',
    subcategory: 'PEP',
    action: 'PEP Operations',
    flow: 'Compliance Flow',
    step: 1,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'pepReport': {
    category: 'Compliance',
    subcategory: 'PEP Reports',
    action: 'PEP Report',
    flow: 'Compliance Flow',
    step: 2,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'osvReport': {
    category: 'Compliance',
    subcategory: 'OSV Reports',
    action: 'OSV Report',
    flow: 'Compliance Flow',
    step: 3,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'iarReport': {
    category: 'Compliance',
    subcategory: 'IRA Reports',
    action: 'IRA Report',
    flow: 'Compliance Flow',
    step: 4,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'fiuReport': {
    category: 'Compliance',
    subcategory: 'FIU Reports',
    action: 'FIU India Report',
    flow: 'Compliance Flow',
    step: 5,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'screeningUtility': {
    category: 'Compliance',
    subcategory: 'Screening',
    action: 'Screening Utility',
    flow: 'Screening Flow',
    step: 1,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'addScreeningUtility': {
    category: 'Compliance',
    subcategory: 'Screening',
    action: 'Add Screening Utility',
    flow: 'Screening Flow',
    step: 2,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'screeningUtilityEdit': {
    category: 'Compliance',
    subcategory: 'Screening',
    action: 'Edit Screening Utility',
    flow: 'Screening Flow',
    step: 3,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'screeningConfiguration': {
    category: 'Compliance',
    subcategory: 'Configuration',
    action: 'Screening Configuration',
    flow: 'Screening Flow',
    step: 4,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'nameScreeningRule': {
    category: 'Compliance',
    subcategory: 'Name Screening',
    action: 'Name Screening Rule',
    flow: 'Screening Flow',
    step: 5,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'baselCountryRule': {
    category: 'Compliance',
    subcategory: 'Country Screening',
    action: 'Basel Country Rule',
    flow: 'Screening Flow',
    step: 6,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },

  // ==================== RISK MANAGEMENT ====================
  'realTimeRiskMonitor': {
    category: 'Risk Management',
    subcategory: 'Real-time Monitoring',
    action: 'Real Time Risk Monitor',
    flow: 'Risk Flow',
    step: 1,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'riskMonitor': {
    category: 'Risk Management',
    subcategory: 'Monitoring',
    action: 'Risk and Monitoring',
    flow: 'Risk Flow',
    step: 2,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'velocityCheck': {
    category: 'Risk Management',
    subcategory: 'Velocity Checks',
    action: 'Velocity Check',
    flow: 'Risk Flow',
    step: 3,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'riskAssessment': {
    category: 'Risk Management',
    subcategory: 'Assessment',
    action: 'Risk Assessment Report',
    flow: 'Risk Flow',
    step: 4,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read'
  },

  // ==================== FRAUD PREVENTION ====================
  'transactionMasterRule': {
    category: 'Fraud Prevention',
    subcategory: 'Transaction Rules',
    action: 'Transaction Master Rule',
    flow: 'Fraud Flow',
    step: 1,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'countryMasterRule': {
    category: 'Fraud Prevention',
    subcategory: 'Country Rules',
    action: 'Country Master Rule',
    flow: 'Fraud Flow',
    step: 2,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },

  // ==================== TRANSACTION MANAGEMENT ====================
  'chargeBack': {
    category: 'Transaction Management',
    subcategory: 'Disputes',
    action: 'Charge Back',
    flow: 'Dispute Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'super-transactions/ledger-only': {
    category: 'Transaction Management',
    subcategory: 'Super Transactions',
    action: 'Ledger Only',
    flow: 'Super Transaction Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'super-admin',
    dataFlow: 'write'
  },
  'super-transactions/ledger-bank': {
    category: 'Transaction Management',
    subcategory: 'Super Transactions',
    action: 'Ledger Bank',
    flow: 'Super Transaction Flow',
    step: 2,
    businessDomain: 'Finance',
    accessLevel: 'super-admin',
    dataFlow: 'write'
  },
  'super-transactions': {
    category: 'Transaction Management',
    subcategory: 'Super Transactions',
    action: 'Super Transaction List',
    flow: 'Super Transaction Flow',
    step: 3,
    businessDomain: 'Finance',
    accessLevel: 'super-admin',
    dataFlow: 'read-write'
  },

  // ==================== PAYMENT GATEWAY ====================
  'merchant-account': {
    category: 'Payment Gateway',
    subcategory: 'Account Management',
    action: 'Merchant Account',
    flow: 'Gateway Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'merchant-account-edit': {
    category: 'Payment Gateway',
    subcategory: 'Account Management',
    action: 'Merchant Account Edit',
    flow: 'Gateway Flow',
    step: 2,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'merchant-mapping': {
    category: 'Payment Gateway',
    subcategory: 'Configuration',
    action: 'Merchant Mapping',
    flow: 'Gateway Flow',
    step: 3,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'tdr-setting': {
    category: 'Payment Gateway',
    subcategory: 'Configuration',
    action: 'TDR Setting',
    flow: 'Gateway Flow',
    step: 4,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'rule-engine': {
    category: 'Payment Gateway',
    subcategory: 'Rules',
    action: 'Rule Engine',
    flow: 'Rules Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'frm-rule': {
    category: 'Payment Gateway',
    subcategory: 'Fraud Management',
    action: 'FRM Rule',
    flow: 'Fraud Flow',
    step: 1,
    businessDomain: 'Risk',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'smartRouter': {
    category: 'Payment Gateway',
    subcategory: 'Routing',
    action: 'Smart Router',
    flow: 'Routing Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'smart-router': {
    category: 'Payment Gateway',
    subcategory: 'Routing',
    action: 'Smart Router',
    flow: 'Routing Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },

  // ==================== REPORTING & RECONCILIATION ====================
  'reconReport': {
    category: 'Reporting',
    subcategory: 'Reconciliation',
    action: 'Reconciliation Report',
    flow: 'Reconciliation Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'reconReport/agentReconReport': {
    category: 'Reporting',
    subcategory: 'Agent Reconciliation',
    action: 'Agent Reconciliation Report',
    flow: 'Reconciliation Flow',
    step: 2,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'reconReport/agentReconReport/customerReconReport': {
    category: 'Reporting',
    subcategory: 'Customer Reconciliation',
    action: 'Customer Wise Reconciliation Report',
    flow: 'Reconciliation Flow',
    step: 3,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'cma-report': {
    category: 'Reporting',
    subcategory: 'Financial Statements',
    action: 'CMA Statement Report',
    flow: 'Financial Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'settlement-report': {
    category: 'Reporting',
    subcategory: 'Settlement',
    action: 'Settlement Report',
    flow: 'Settlement Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'grievanceReport': {
    category: 'Reporting',
    subcategory: 'Grievance',
    action: 'Grievance Report',
    flow: 'Support Flow',
    step: 1,
    businessDomain: 'Support',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'grievanceEdit': {
    category: 'Reporting',
    subcategory: 'Grievance',
    action: 'Grievance Edit',
    flow: 'Support Flow',
    step: 2,
    businessDomain: 'Support',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'mismatchReport': {
    category: 'Reporting',
    subcategory: 'Data Quality',
    action: 'Mismatch Report',
    flow: 'Quality Flow',
    step: 1,
    businessDomain: 'Quality',
    accessLevel: 'admin',
    dataFlow: 'read'
  },

  // ==================== DOCUMENT MANAGEMENT ====================
  'documents': {
    category: 'Document Management',
    action: 'Documents',
    flow: 'Document Flow',
    step: 1,
    businessDomain: 'Operations',
    accessLevel: 'authenticated',
    dataFlow: 'read-write'
  },
  'document-upload': {
    category: 'Document Management',
    subcategory: 'Upload',
    action: 'Document Upload',
    flow: 'Document Flow',
    step: 2,
    businessDomain: 'Operations',
    accessLevel: 'authenticated',
    dataFlow: 'write'
  },
  'passportCheckNumber': {
    category: 'Document Management',
    subcategory: 'Verification',
    action: 'Passport Check Number',
    flow: 'Verification Flow',
    step: 1,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'passportCheckImage': {
    category: 'Document Management',
    subcategory: 'Image Processing',
    action: 'Passport Check Image',
    flow: 'Verification Flow',
    step: 2,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'submittedBatch': {
    category: 'Document Management',
    subcategory: 'Batch Processing',
    action: 'Submitted Batch',
    flow: 'Batch Flow',
    step: 1,
    businessDomain: 'Operations',
    accessLevel: 'admin',
    dataFlow: 'read'
  },

  // ==================== PRODUCT MANAGEMENT ====================
  'productManagement/productList': {
    category: 'Product Management',
    action: 'Product List',
    flow: 'Product Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'productManagement/productAdd': {
    category: 'Product Management',
    action: 'Product Add',
    flow: 'Product Flow',
    step: 2,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'productManagement/productEdit': {
    category: 'Product Management',
    action: 'Product Edit',
    flow: 'Product Flow',
    step: 3,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'productCategory/productCategoryList': {
    category: 'Product Management',
    subcategory: 'Categories',
    action: 'Product Category List',
    flow: 'Product Flow',
    step: 4,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'productCategory/productCategoryAdd': {
    category: 'Product Management',
    subcategory: 'Categories',
    action: 'Product Category Add',
    flow: 'Product Flow',
    step: 5,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'productCategory/productCategoryEdit': {
    category: 'Product Management',
    subcategory: 'Categories',
    action: 'Product Category Edit',
    flow: 'Product Flow',
    step: 6,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'productSubcategory/productSubcategoryList': {
    category: 'Product Management',
    subcategory: 'Subcategories',
    action: 'Product Subcategory List',
    flow: 'Product Flow',
    step: 7,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'productSubcategory/productSubcategoryAdd': {
    category: 'Product Management',
    subcategory: 'Subcategories',
    action: 'Product Subcategory Add',
    flow: 'Product Flow',
    step: 8,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'productSubcategory/productSubcategoryEdit': {
    category: 'Product Management',
    subcategory: 'Subcategories',
    action: 'Product Subcategory Edit',
    flow: 'Product Flow',
    step: 9,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'serviceProviderList': {
    category: 'Product Management',
    subcategory: 'Service Providers',
    action: 'Service Provider List',
    flow: 'Provider Flow',
    step: 1,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'serviceProvider/serviceProviderAdd': {
    category: 'Product Management',
    subcategory: 'Service Providers',
    action: 'Service Provider Add',
    flow: 'Provider Flow',
    step: 2,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'serviceProvider/serviceProviderEdit': {
    category: 'Product Management',
    subcategory: 'Service Providers',
    action: 'Service Provider Edit',
    flow: 'Provider Flow',
    step: 3,
    businessDomain: 'Business',
    accessLevel: 'admin',
    dataFlow: 'write'
  },

  // ==================== FINANCIAL OPERATIONS ====================
  'exchangeRates': {
    category: 'Financial Operations',
    subcategory: 'Exchange Rates',
    action: 'Exchange Rates',
    flow: 'Financial Flow',
    step: 1,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'exchangeRates/Edit': {
    category: 'Financial Operations',
    subcategory: 'Exchange Rates',
    action: 'Exchange Rate Edit',
    flow: 'Financial Flow',
    step: 2,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'commissionProfile': {
    category: 'Financial Operations',
    subcategory: 'Commission',
    action: 'Commission Profile',
    flow: 'Financial Flow',
    step: 3,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'commissionProfile/Add': {
    category: 'Financial Operations',
    subcategory: 'Commission',
    action: 'Commission Profile Add',
    flow: 'Financial Flow',
    step: 4,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'write'
  },
  'commissionProfile/Edit': {
    category: 'Financial Operations',
    subcategory: 'Commission',
    action: 'Commission Profile Edit',
    flow: 'Financial Flow',
    step: 5,
    businessDomain: 'Finance',
    accessLevel: 'admin',
    dataFlow: 'write'
  },

  // ==================== UTILITIES & TOOLS ====================
  'userManual': {
    category: 'Utilities',
    subcategory: 'Documentation',
    action: 'User Manual',
    flow: 'Documentation Flow',
    step: 1,
    businessDomain: 'Support',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'integrationKit': {
    category: 'Utilities',
    subcategory: 'Integration',
    action: 'Integration Kit',
    flow: 'Integration Flow',
    step: 1,
    businessDomain: 'Operations',
    accessLevel: 'authenticated',
    dataFlow: 'read'
  },
  'auditTrail': {
    category: 'Utilities',
    subcategory: 'Audit',
    action: 'Audit Trail',
    flow: 'Audit Flow',
    step: 1,
    businessDomain: 'Compliance',
    accessLevel: 'admin',
    dataFlow: 'read'
  },
  'testPage': {
    category: 'Utilities',
    subcategory: 'Testing',
    action: 'Test Page',
    flow: 'Test Flow',
    step: 1,
    businessDomain: 'Operations',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },
  'static-qr': {
    category: 'Utilities',
    subcategory: 'QR Code',
    action: 'QR Code Generation',
    flow: 'Utility Flow',
    step: 1,
    businessDomain: 'Operations',
    accessLevel: 'authenticated',
    dataFlow: 'read-write'
  },

  // ==================== CRASHING MODULE ====================
  'crashing': {
    category: 'Utilities',
    subcategory: 'System Management',
    action: 'Crashing Module',
    flow: 'System Flow',
    step: 1,
    businessDomain: 'Operations',
    accessLevel: 'admin',
    dataFlow: 'read-write'
  },

  // ==================== ERROR HANDLING ====================
  'error': {
    category: 'System',
    subcategory: 'Error Handling',
    action: 'Error Page',
    flow: 'Error Flow',
    step: 1,
    businessDomain: 'System',
    accessLevel: 'public',
    dataFlow: 'read'
  },
  'error/:type': {
    category: 'System',
    subcategory: 'Error Handling',
    action: 'Typed Error Page',
    flow: 'Error Flow',
    step: 2,
    businessDomain: 'System',
    accessLevel: 'public',
    dataFlow: 'read'
  }
};
